
export interface TimeEntry {
	id: string
	date: Date
	time: number
}

export enum TimeEntryInputFormat {
    Decimal = "decimal",
    HoursMinutes = "hoursMinutes",
}
